// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","570":"component---src-templates-md-templates-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"113e148139855b87c192","532":"197625a8e3908b70cf20","570":"54b1c8ee9668303acaaf","883":"2c0632a6f5d23a8653ad"}[chunkId] + ".js";
};